/// <reference path="../../../typings/index.d.ts" />
/// <reference path="../apimodel.d.ts" />

module App.Common {
	'use strict';

	// ReSharper disable InconsistentNaming
	export class OAuthToken {

		public access_token: string;

		public expires_in: string;

		public token_type: string;

        public refresh_token: string;

		public "as:client_id": string;

		public userName: string;

		public ".issued": string;

		public ".expires": string;
	}
	// ReSharper restore InconsistentNaming

}